/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * 目标语言代码。请从支持的语言列表中选择一个语言代码。
 */
export const TargetLang = {
  Sq: "sq",
  Ga: "ga",
  Et: "et",
  Ar: "ar",
  Am: "am",
  Az: "az",
  Be: "be",
  Bg: "bg",
  Eu: "eu",
  Is: "is",
  Pl: "pl",
  BsLatn: "bs-Latn",
  Fa: "fa",
  Da: "da",
  De: "de",
  Ru: "ru",
  Fr: "fr",
  Tl: "tl",
  Fi: "fi",
  Fy: "fy",
  Km: "km",
  Ka: "ka",
  Gu: "gu",
  Ht: "ht",
  Ko: "ko",
  Ha: "ha",
  Kk: "kk",
  Nl: "nl",
  Gl: "gl",
  Ca: "ca",
  Cs: "cs",
  Ky: "ky",
  Kn: "kn",
  Tlh: "tlh",
  Hr: "hr",
  Otq: "otq",
  Co: "co",
  Ku: "ku",
  La: "la",
  Lo: "lo",
  Lv: "lv",
  Lt: "lt",
  Ro: "ro",
  Lb: "lb",
  Mg: "mg",
  Mt: "mt",
  Mr: "mr",
  Ms: "ms",
  Ml: "ml",
  Mi: "mi",
  Mk: "mk",
  Mn: "mn",
  Bn: "bn",
  My: "my",
  Mww: "mww",
  Hmn: "hmn",
  Xh: "xh",
  Zu: "zu",
  Ne: "ne",
  No: "no",
  Pa: "pa",
  Ps: "ps",
  Pt: "pt",
  Ny: "ny",
  Ja: "ja",
  Sv: "sv",
  SrLatn: "sr-Latn",
  SrCyrl: "sr-Cyrl",
  St: "st",
  Sm: "sm",
  Si: "si",
  Eo: "eo",
  Sk: "sk",
  Sl: "sl",
  Sw: "sw",
  Gd: "gd",
  So: "so",
  Ceb: "ceb",
  Te: "te",
  Ta: "ta",
  Th: "th",
  Tg: "tg",
  Tr: "tr",
  Cy: "cy",
  ZhLzh: "zh-lzh",
  Ur: "ur",
  Uk: "uk",
  Uz: "uz",
  Haw: "haw",
  Es: "es",
  He: "he",
  El: "el",
  Sd: "sd",
  Hu: "hu",
  Sn: "sn",
  Hy: "hy",
  Ig: "ig",
  It: "it",
  Yi: "yi",
  Hi: "hi",
  Id: "id",
  En: "en",
  Su: "su",
  Jw: "jw",
  Yua: "yua",
  Yo: "yo",
  Vi: "vi",
  ZhCHS: "zh-CHS",
  ZhCHT: "zh-CHT",
} as const;
/**
 * 目标语言代码。请从支持的语言列表中选择一个语言代码。
 */
export type TargetLang = ClosedEnum<typeof TargetLang>;

export const TargetLang$zodSchema = z.enum([
  "sq",
  "ga",
  "et",
  "ar",
  "am",
  "az",
  "be",
  "bg",
  "eu",
  "is",
  "pl",
  "bs-Latn",
  "fa",
  "da",
  "de",
  "ru",
  "fr",
  "tl",
  "fi",
  "fy",
  "km",
  "ka",
  "gu",
  "ht",
  "ko",
  "ha",
  "kk",
  "nl",
  "gl",
  "ca",
  "cs",
  "ky",
  "kn",
  "tlh",
  "hr",
  "otq",
  "co",
  "ku",
  "la",
  "lo",
  "lv",
  "lt",
  "ro",
  "lb",
  "mg",
  "mt",
  "mr",
  "ms",
  "ml",
  "mi",
  "mk",
  "mn",
  "bn",
  "my",
  "mww",
  "hmn",
  "xh",
  "zu",
  "ne",
  "no",
  "pa",
  "ps",
  "pt",
  "ny",
  "ja",
  "sv",
  "sr-Latn",
  "sr-Cyrl",
  "st",
  "sm",
  "si",
  "eo",
  "sk",
  "sl",
  "sw",
  "gd",
  "so",
  "ceb",
  "te",
  "ta",
  "th",
  "tg",
  "tr",
  "cy",
  "zh-lzh",
  "ur",
  "uk",
  "uz",
  "haw",
  "es",
  "he",
  "el",
  "sd",
  "hu",
  "sn",
  "hy",
  "ig",
  "it",
  "yi",
  "hi",
  "id",
  "en",
  "su",
  "jw",
  "yua",
  "yo",
  "vi",
  "zh-CHS",
  "zh-CHT",
]).describe("目标语言代码。请从支持的语言列表中选择一个语言代码。");

/**
 * 翻译风格，可选。支持casual(随意口语化)、professional(专业商务，默认)、academic(学术正式)、literary(文学艺术)。
 */
export const PostAiTranslateStyle = {
  Casual: "casual",
  Professional: "professional",
  Academic: "academic",
  Literary: "literary",
} as const;
/**
 * 翻译风格，可选。支持casual(随意口语化)、professional(专业商务，默认)、academic(学术正式)、literary(文学艺术)。
 */
export type PostAiTranslateStyle = ClosedEnum<typeof PostAiTranslateStyle>;

export const PostAiTranslateStyle$zodSchema = z.enum([
  "casual",
  "professional",
  "academic",
  "literary",
]).describe(
  "翻译风格，可选。支持casual(随意口语化)、professional(专业商务，默认)、academic(学术正式)、literary(文学艺术)。",
);

/**
 * 翻译上下文场景，可选。支持general(通用，默认)、business(商务)、technical(技术)、medical(医疗)、legal(法律)、marketing(市场营销)、entertainment(娱乐)、education(教育)、news(新闻)。
 */
export const PostAiTranslateContext = {
  General: "general",
  Business: "business",
  Technical: "technical",
  Medical: "medical",
  Legal: "legal",
  Marketing: "marketing",
  Entertainment: "entertainment",
  Education: "education",
  News: "news",
} as const;
/**
 * 翻译上下文场景，可选。支持general(通用，默认)、business(商务)、technical(技术)、medical(医疗)、legal(法律)、marketing(市场营销)、entertainment(娱乐)、education(教育)、news(新闻)。
 */
export type PostAiTranslateContext = ClosedEnum<typeof PostAiTranslateContext>;

export const PostAiTranslateContext$zodSchema = z.enum([
  "general",
  "business",
  "technical",
  "medical",
  "legal",
  "marketing",
  "entertainment",
  "education",
  "news",
]).describe(
  "翻译上下文场景，可选。支持general(通用，默认)、business(商务)、technical(技术)、medical(医疗)、legal(法律)、marketing(市场营销)、entertainment(娱乐)、education(教育)、news(新闻)。",
);

/**
 * 包含翻译参数的JSON对象，支持单个文本或批量文本翻译
 */
export type PostAiTranslateRequestBody = {
  text?: string | undefined;
  texts?: Array<string> | undefined;
  source_lang?: string | undefined;
  style?: PostAiTranslateStyle | undefined;
  context?: PostAiTranslateContext | undefined;
  preserve_format?: boolean | undefined;
  fast_mode?: boolean | undefined;
  max_concurrency?: number | undefined;
};

export const PostAiTranslateRequestBody$zodSchema: z.ZodType<
  PostAiTranslateRequestBody
> = z.object({
  context: PostAiTranslateContext$zodSchema.default("general"),
  fast_mode: z.boolean().default(false),
  max_concurrency: z.int().default(3),
  preserve_format: z.boolean().default(true),
  source_lang: z.string().optional(),
  style: PostAiTranslateStyle$zodSchema.default("professional"),
  text: z.string().optional(),
  texts: z.array(z.string()).optional(),
}).describe("包含翻译参数的JSON对象，支持单个文本或批量文本翻译");

export type PostAiTranslateRequest = {
  target_lang: TargetLang;
  body: PostAiTranslateRequestBody;
};

export const PostAiTranslateRequest$zodSchema: z.ZodType<
  PostAiTranslateRequest
> = z.object({
  body: z.lazy(() => PostAiTranslateRequestBody$zodSchema),
  target_lang: TargetLang$zodSchema,
});

/**
 * 翻译服务内部错误。请稍后重试或联系技术支持。
 */
export type PostAiTranslateInternalServerErrorResponseBody = {
  code?: number | undefined;
  message?: string | undefined;
  error?: string | undefined;
  is_batch?: boolean | undefined;
};

export const PostAiTranslateInternalServerErrorResponseBody$zodSchema:
  z.ZodType<PostAiTranslateInternalServerErrorResponseBody> = z.object({
    code: z.int().optional(),
    error: z.string().optional(),
    is_batch: z.boolean().optional(),
    message: z.string().optional(),
  }).describe("翻译服务内部错误。请稍后重试或联系技术支持。");

/**
 * 请求频率过高。请稍后重试。
 */
export type PostAiTranslateTooManyRequestsResponseBody = {
  code?: number | undefined;
  message?: string | undefined;
  error?: string | undefined;
};

export const PostAiTranslateTooManyRequestsResponseBody$zodSchema: z.ZodType<
  PostAiTranslateTooManyRequestsResponseBody
> = z.object({
  code: z.int().optional(),
  error: z.string().optional(),
  message: z.string().optional(),
}).describe("请求频率过高。请稍后重试。");

/**
 * 认证失败。请检查API密钥是否有效。
 */
export type PostAiTranslateUnauthorizedResponseBody = {
  code?: number | undefined;
  message?: string | undefined;
  error?: string | undefined;
};

export const PostAiTranslateUnauthorizedResponseBody$zodSchema: z.ZodType<
  PostAiTranslateUnauthorizedResponseBody
> = z.object({
  code: z.int().optional(),
  error: z.string().optional(),
  message: z.string().optional(),
}).describe("认证失败。请检查API密钥是否有效。");

/**
 * 请求参数错误。请检查必填参数和参数格式是否正确。
 */
export type PostAiTranslateBadRequestResponseBody = {
  code?: number | undefined;
  message?: string | undefined;
  error?: string | undefined;
};

export const PostAiTranslateBadRequestResponseBody$zodSchema: z.ZodType<
  PostAiTranslateBadRequestResponseBody
> = z.object({
  code: z.int().optional(),
  error: z.string().optional(),
  message: z.string().optional(),
}).describe("请求参数错误。请检查必填参数和参数格式是否正确。");

export type KeyPhrase = {};

export const KeyPhrase$zodSchema: z.ZodType<KeyPhrase> = z.object({});

export type Explanation = {
  key_phrases?: Array<KeyPhrase> | undefined;
  cultural_notes?: Array<string> | undefined;
  grammar_notes?: Array<string> | undefined;
};

export const Explanation$zodSchema: z.ZodType<Explanation> = z.object({
  cultural_notes: z.array(z.string()).optional(),
  grammar_notes: z.array(z.string()).optional(),
  key_phrases: z.array(z.lazy(() => KeyPhrase$zodSchema)).optional(),
});

/**
 * 单个翻译的详细结果，仅在单个翻译时返回。
 */
export type PostAiTranslateData = {
  original_text?: string | undefined;
  translated_text?: string | undefined;
  detected_lang?: string | undefined;
  confidence_score?: number | undefined;
  alternatives?: Array<string> | undefined;
  explanation?: Explanation | undefined;
};

export const PostAiTranslateData$zodSchema: z.ZodType<PostAiTranslateData> = z
  .object({
    alternatives: z.array(z.string()).optional(),
    confidence_score: z.number().optional(),
    detected_lang: z.string().optional(),
    explanation: z.lazy(() => Explanation$zodSchema).optional(),
    original_text: z.string().optional(),
    translated_text: z.string().optional(),
  }).describe("单个翻译的详细结果，仅在单个翻译时返回。");

export type BatchDatum = {
  original_text?: string | undefined;
  translated_text?: string | undefined;
  confidence_score?: number | undefined;
};

export const BatchDatum$zodSchema: z.ZodType<BatchDatum> = z.object({
  confidence_score: z.number().optional(),
  original_text: z.string().optional(),
  translated_text: z.string().optional(),
});

/**
 * 批量翻译汇总信息，仅在批量翻译时返回。
 */
export type BatchSummary = {
  total_items?: number | undefined;
  success_items?: number | undefined;
  failed_items?: number | undefined;
  average_quality?: number | undefined;
};

export const BatchSummary$zodSchema: z.ZodType<BatchSummary> = z.object({
  average_quality: z.number().optional(),
  failed_items: z.int().optional(),
  success_items: z.int().optional(),
  total_items: z.int().optional(),
}).describe("批量翻译汇总信息，仅在批量翻译时返回。");

export type PostAiTranslatePerformance = {
  processing_time_ms?: number | undefined;
  cache_hit?: boolean | undefined;
};

export const PostAiTranslatePerformance$zodSchema: z.ZodType<
  PostAiTranslatePerformance
> = z.object({
  cache_hit: z.boolean().optional(),
  processing_time_ms: z.int().optional(),
});

/**
 * 翻译质量指标，仅在单个翻译时返回。
 */
export type QualityMetrics = {
  fluency_score?: number | undefined;
  accuracy_score?: number | undefined;
  completeness_score?: number | undefined;
  total_score?: number | undefined;
};

export const QualityMetrics$zodSchema: z.ZodType<QualityMetrics> = z.object({
  accuracy_score: z.number().optional(),
  completeness_score: z.number().optional(),
  fluency_score: z.number().optional(),
  total_score: z.number().optional(),
}).describe("翻译质量指标，仅在单个翻译时返回。");

/**
 * 翻译成功！返回翻译结果、质量指标和性能统计。
 */
export type PostAiTranslateResponseBody = {
  message?: string | undefined;
  is_batch?: boolean | undefined;
  data?: PostAiTranslateData | undefined;
  batch_data?: Array<BatchDatum> | undefined;
  batch_summary?: BatchSummary | undefined;
  performance?: PostAiTranslatePerformance | undefined;
  quality_metrics?: QualityMetrics | undefined;
};

export const PostAiTranslateResponseBody$zodSchema: z.ZodType<
  PostAiTranslateResponseBody
> = z.object({
  batch_data: z.array(z.lazy(() => BatchDatum$zodSchema)).optional(),
  batch_summary: z.lazy(() => BatchSummary$zodSchema).optional(),
  data: z.lazy(() => PostAiTranslateData$zodSchema).optional(),
  is_batch: z.boolean().optional(),
  message: z.string().optional(),
  performance: z.lazy(() => PostAiTranslatePerformance$zodSchema).optional(),
  quality_metrics: z.lazy(() => QualityMetrics$zodSchema).optional(),
}).describe("翻译成功！返回翻译结果、质量指标和性能统计。");

export type PostAiTranslateResponse =
  | PostAiTranslateResponseBody
  | PostAiTranslateBadRequestResponseBody
  | PostAiTranslateUnauthorizedResponseBody
  | PostAiTranslateTooManyRequestsResponseBody
  | PostAiTranslateInternalServerErrorResponseBody;

export const PostAiTranslateResponse$zodSchema: z.ZodType<
  PostAiTranslateResponse
> = z.union([
  z.lazy(() => PostAiTranslateResponseBody$zodSchema),
  z.lazy(() => PostAiTranslateBadRequestResponseBody$zodSchema),
  z.lazy(() => PostAiTranslateUnauthorizedResponseBody$zodSchema),
  z.lazy(() => PostAiTranslateTooManyRequestsResponseBody$zodSchema),
  z.lazy(() => PostAiTranslateInternalServerErrorResponseBody$zodSchema),
]);
